import React, { FC, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { ToggleBlock } from "../../../components/ToggleBlock/ToggleBlock";

import { setPrintTitle } from "../../../ducks/print/print";
import { useProjectTitle } from "../../../ducks/project/hooks";
import { getPrintTitle, getPrintWithTitle } from "../../../ducks/print/selectors";
import { useAction } from "../../../hooks/useAction";

export const TitleSetting: FC = () => {
  const { t } = useTranslation("print");
  const dispatch = useDispatch();
  const projectTitle = useProjectTitle();
  const printTitle = useSelector(getPrintTitle);
  const titleEnabled = useSelector(getPrintWithTitle);
  const updateTitle = useAction(setPrintTitle);

  const toggleEnableTitle = useCallback(
    () => updateTitle(titleEnabled ? null : printTitle || projectTitle),
    [updateTitle, titleEnabled, printTitle, projectTitle],
  );

  const changeTitle = useCallback(
    e => {
      dispatch(setPrintTitle(e.target.value));
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch(setPrintTitle(projectTitle));
  }, []);

  return (
    <ToggleBlock label={t("mapTitle")} checked={titleEnabled} onChange={toggleEnableTitle}>
      <Input
        style={{ marginBottom: "1rem" }}
        width="19.5rem"
        label={t("title")}
        placeholder={t("placeholder")}
        value={printTitle}
        onChange={changeTitle}
        autoFocus
      />
    </ToggleBlock>
  );
};
